import Vue from 'vue';
import debounce from 'lodash/debounce';
import domHelper from '../scripts/utils/dom-helper';
import GetElSlots from '../scripts/mixins/get-el-slots';
import Emitter from '../scripts/mixins/emitter';
import { addResizeListener, removeResizeListener } from '../scripts/utils/resize-observer';

const name = 'ten-popup';
function getDirMatch(direction) {
  /* eslint-disable */
  let dirMatch = direction.match(/((top|bottom|center|left|right)[\s-]*)/gi);
  dirMatch = !dirMatch ? ['top', 'center'] : dirMatch.map(dir => dir.replace(/[\s-]/g, ''));
  /* eslint-enable */

  if (dirMatch.length === 1) {
    dirMatch[1] = 'center';
  }

  if (
    (dirMatch[0] === 'left' && dirMatch[1] === 'right')
    || (dirMatch[0] === 'right' && dirMatch[1] === 'left')
    || (dirMatch[0] === 'top' && dirMatch[1] === 'bottom')
    || (dirMatch[0] === 'bottom' && dirMatch[1] === 'top')
  ) {
    dirMatch[1] = 'center';
  }

  if (dirMatch[0] === 'center') {
    if (dirMatch[1] === 'center') {
      dirMatch = ['top', 'center'];
    }
    dirMatch.reverse();
  } else if (dirMatch[0] === dirMatch[1]) {
    dirMatch[1] = 'center';
  }
  dirMatch[0] = dirMatch[0].trim();
  dirMatch[1] = dirMatch[1].trim();
  return dirMatch;
}

export default {
  name,
  mixins: [GetElSlots, Emitter],
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    /**
     * 弹窗方向
     */
    direction: {
      type: String,
      default: 'top center',
    },
    /**
     * 是否显示
     */
    show: Boolean,
    /**
     * 隐藏时是否销毁
     */
    destroy: {
      type: Boolean,
      default: true,
    },
    disabled: Boolean,
    /**
     * 获取弹窗内容宽度
     */
    width: [Number, Function],
    /**
     * 设置弹窗偏移量，{ x, y }
     */
    offset: Object,
    /**
     * 触发方式
     */
    triggerType: {
      validator: val => ['click', 'hover', 'manual'].indexOf(val) > -1,
      default: 'click',
    },
    /**
     * 弹框 class
     */
    popupClass: [String, Object, Array],
    /**
     * 类型
     * @member default | bubble
     */
    type: {
      type: String,
      default: 'default',
    },
  },

  data() {
    return {
      popupShowed: false,
    };
  },

  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.popupShowed = val;
      },
    },
    disabled(v) {
      if (v && this.popupShowed && this.triggerType !== 'manual') {
        this.popupShowed = false;
      }
    }
  },

  render(h) { // eslint-disable-line
    const triggerSlots = this.$scopedSlots.trigger
      ? this.$scopedSlots.trigger()
      : null;
    const defaultSlot = this.$scopedSlots.default
      ? this.$scopedSlots.default()
      : null;

    let trigger = null;
    if (triggerSlots) {
      for (let i = 0; i < triggerSlots.length; i++) {
        if (triggerSlots[i].tag) {
          trigger = triggerSlots[i];
          break;
        }
      }
    }

    this.popupComponent.content = (this.popupShowed || !this.destroy) ? defaultSlot : null;
    this.popupComponent.destroy = this.destroy;
    this.popupComponent.show = this.popupShowed && trigger;
    this.popupComponent.popupClass = this.popupClass;
    this.popupComponent.type = this.type;
    const dirMatch = getDirMatch(this.direction);
    this.popupComponent.dir = dirMatch;

    return trigger;
  },

  beforeCreate() {
    const resize = () => {
      this.resize();
    };
    let visibleT = 0;

    this.globalEventBinded = false;
    this.popupElemEventBinded = false;
    this.popupComponent = new Vue({
      parent: this,
      data() {
        return {
          type: 'default',
          content: null,
          dataContent: null,
          popupClass: '',
          dir: [],
          show: false,
          destroy: false,
        };
      },
      watch: {
        content: {
          handler(v) {
            clearTimeout(visibleT);
            if (v) {
              this.dataContent = v;
            } else {
              visibleT = setTimeout(() => {
                this.dataContent = null;
              }, 300);
            }
          },
          immediate: true,
        },
      },
      methods: {
        onAfterLeave() {
          if (this.destroy) {
            try {
              document.body.removeChild(this.$el);
            } catch (e) { }
          }
        },
      },
      updated() {
        if (this.$refs.popup) {
          removeResizeListener(this.$refs.popup, resize);
          addResizeListener(this.$refs.popup, resize);
          this.$refs.popup.tenPopupParentNode = this.$parent.$el;
        }
      },
      beforeDestroy() {
        if (this.$refs.popup) {
          removeResizeListener(this.$refs.popup, resize);
          this.$refs.popup.tenPopupParentNode = null;
        }
      },
      render(h) { // eslint-disable-line
        const popupClass = [
          'ten-popup',
          `ten-popup--p-${this.dir[0]}-${this.dir[1]}`,
          `ten-popup--type-${this.type}`,
          this.popupClass,
        ];

        return this.dataContent ? (
          // appear确保初次渲染的时候依然有过渡动画
          <transition name="ten-flow-in__popup" appear={true} onAfterLeave={() => {
            this.onAfterLeave();
          }}>
            <div class={popupClass} v-show={this.show && this.content} ref="popup">
              {this.dataContent}
            </div>
          </transition>
        ) : null;
      },
    });
    this.popupComponent.$mount();
  },

  mounted() {
    this.bindTriggerElemEvent();
    this.afterRender();
    this.setPopupPosition = debounce(this.setPopupPosition.bind(this), 16);
  },

  updated() {
    this.bindTriggerElemEvent();
    this.afterRender();
  },

  beforeDestroy() {
    this.unbindGlobalEvent();
    this.removePopupElem();
    this.popupComponent.$destroy();
  },

  methods: {
    afterRender() {
      if (this.popupShowed) {
        this.appendPopupElem();
        this.bindPopupElemEvent();
        if (this.triggerType === 'click' || this.triggerType === 'manual') {
          this.bindGlobalEvent();
        }
        this.dirMatch = getDirMatch(this.direction);
        this.$nextTick(function() {
          this.setPopupPosition();
        });
      } else {
        this.unbindGlobalEvent();
        this.unbindPopupElemEvent();
      }
    },

    appendPopupElem() {
      try {
        if (this.popupComponent.$el.parentNode === document.body) {
          return;
        }
        document.body.appendChild(this.popupComponent.$el);
        this.broadcastAll('do-layout');
      } catch (e) { }
    },

    removePopupElem() {
      try {
        document.body.removeChild(this.popupComponent.$el);
      } catch (e) { }
    },

    bindTriggerElemEvent() {
      this.triggerElem = this.$el;
      if (this.triggerElem) {
        if (this.triggerType === 'click') {
          this.triggerElem.addEventListener('click', this.onClick);
        }
        if (this.triggerType === 'hover') {
          this.triggerElem.addEventListener('mouseenter', this.onMouseenter);
          this.triggerElem.addEventListener('mouseleave', this.onMouseleave);
        }
      }
    },

    bindPopupElemEvent() {
      if (this.popupComponent.$el && !this.popupElemEventBinded) {
        this.popupElemEventBinded = true;
        if (this.triggerType === 'hover') {
          this.popupComponent.$el.addEventListener(
            'mouseenter',
            this.onMouseenter
          );
          this.popupComponent.$el.addEventListener(
            'mouseleave',
            this.onMouseleave
          );
        }
      }
    },

    unbindPopupElemEvent() {
      if (this.popupComponent.$el) {
        this.popupElemEventBinded = false;
        if (this.triggerType === 'hover') {
          this.popupComponent.$el.removeEventListener(
            'mouseenter',
            this.onMouseenter
          );
          this.popupComponent.$el.removeEventListener(
            'mouseleave',
            this.onMouseleave
          );
        }
      }
    },

    bindGlobalEvent() {
      if (!this.globalEventBinded) {
        this.globalEventBinded = true;
        window.addEventListener('resize', this.setPopupPosition);
        window.addEventListener('scroll', this.setPopupPosition);
        document.addEventListener('scroll', this.setPopupPosition, true);
        document.addEventListener('click', this.onClickOutside);
        document.addEventListener('keydown', this.onKeydown);
      }
    },

    unbindGlobalEvent() {
      this.globalEventBinded = false;
      window.removeEventListener('resize', this.setPopupPosition);
      window.removeEventListener('scroll', this.setPopupPosition);
      document.removeEventListener('scroll', this.setPopupPosition, true);
      document.removeEventListener('click', this.onClickOutside);
      document.removeEventListener('keydown', this.onKeydown);
    },

    setPopupPosition() {
      this.popupElem = this.popupComponent.$el;

      const show = this.popupShowed;
      const padding = 0;
      const dirMatch = [...this.dirMatch];
      // const padding = 16;
      const { triggerElem } = this;
      const isTriggerFixed = getComputedStyle(triggerElem).position === 'fixed';

      // console.log('setPopupPosition', triggerElem, this.popupElem);
      if (
        !show
        || !triggerElem
        || !this.popupElem
        || triggerElem.nodeType !== 1
        || this.popupElem.nodeType !== 1
      ) {
        return;
      }

      const winHeight = window.innerHeight;
      const winWidth = window.innerWidth;
      const triggerElemRect = triggerElem.getBoundingClientRect();
      const popupElemRect = this.popupElem.getBoundingClientRect();
      const popupStyle = {
        position: isTriggerFixed ? 'fixed' : 'absolute',
      };

      let popupElemRectWidth = popupElemRect.width;

      if (typeof this.width !== 'undefined') {
        const { width } = this;
        let w;
        if (typeof width === 'function') {
          w = width(triggerElem);
        } else {
          w = width;
        }
        popupElemRectWidth = w + (padding * 2);
        popupStyle.width = w + (padding * 2);
      }

      // If there is not enough space in the specified direction, set it to the opposite direction
      if (
        dirMatch[0] === 'top'
        && popupElemRect.height > triggerElemRect.top
        && popupElemRect.height < winHeight - triggerElemRect.top - triggerElemRect.height
      ) {
        dirMatch[0] = 'bottom';
      }
      if (
        dirMatch[0] === 'bottom'
        && popupElemRect.height
        > winHeight - triggerElemRect.top - triggerElemRect.height
        && popupElemRect.height < triggerElemRect.top
      ) {
        dirMatch[0] = 'top';
      }
      if (
        dirMatch[0] === 'left'
        && popupElemRectWidth > triggerElemRect.left
        && popupElemRectWidth < winWidth - triggerElemRect.left - triggerElemRect.width
      ) {
        dirMatch[0] = 'right';
      }
      if (
        dirMatch[0] === 'right'
        && popupElemRectWidth > winWidth - triggerElemRect.left - triggerElemRect.width
        && popupElemRectWidth < triggerElemRect.left
      ) {
        dirMatch[0] = 'left';
      }

      if (dirMatch[1] === 'top' && popupElemRect.height > winHeight - triggerElemRect.top) {
        dirMatch[1] = 'bottom';
      } else if (dirMatch[1] === 'bottom' && popupElemRect.height > triggerElemRect.top + triggerElemRect.height) {
        dirMatch[1] = 'top';
      }
      if (dirMatch[1] === 'left' && popupElemRectWidth > winWidth - triggerElemRect.left) {
        dirMatch[1] = 'right';
      } else if (dirMatch[1] === 'right' && popupElemRectWidth > triggerElemRect.left + triggerElemRect.width) {
        dirMatch[1] = 'left';
      }
      if (dirMatch[0] === 'bottom' || dirMatch[0] === 'top') {
        if (dirMatch[1] === 'center' && popupElemRectWidth) {
          const leftSpaceRemain = triggerElemRect.left + (triggerElemRect.width / 2);
          const rightSpaceRemain = winWidth - leftSpaceRemain;
          if (popupElemRectWidth / 2 > leftSpaceRemain && popupElemRectWidth / 2 < rightSpaceRemain) {
            dirMatch[1] = 'left';
          } else if (popupElemRectWidth / 2 > rightSpaceRemain && popupElemRectWidth / 2 < leftSpaceRemain) {
            dirMatch[1] = 'right';
          }
        }
      }

      // style
      if (dirMatch[0] === 'top') {
        popupStyle.top = triggerElemRect.top - popupElemRect.height;
      } else if (dirMatch[0] === 'bottom') {
        popupStyle.top = triggerElemRect.top + triggerElemRect.height;
      } else if (dirMatch[0] === 'left') {
        popupStyle.left = triggerElemRect.left - popupElemRectWidth;
      } else if (dirMatch[0] === 'right') {
        popupStyle.left = triggerElemRect.left + triggerElemRect.width;
      }

      if (dirMatch[1] === 'top') {
        popupStyle.top = triggerElemRect.top - padding;
      } else if (dirMatch[1] === 'bottom') {
        popupStyle.top =          triggerElemRect.top
          + triggerElemRect.height
          - popupElemRect.height
          + padding;
      } else if (dirMatch[1] === 'left') {
        popupStyle.left = triggerElemRect.left - padding;
      } else if (dirMatch[1] === 'right') {
        popupStyle.left =          triggerElemRect.left
          + triggerElemRect.width
          - popupElemRectWidth
          + padding;
      } else {
        /* eslint-disable */
        // center
        if (dirMatch[0] === 'top' || dirMatch[0] === 'bottom') {
          popupStyle.left =
            triggerElemRect.left -
            (popupElemRectWidth - triggerElemRect.width) / 2;
        } else {
          popupStyle.top =
            triggerElemRect.top -
            (popupElemRect.height - triggerElemRect.height) / 2;
        }
        /* eslint-enable */
      }

      if (dirMatch[0] === 'top') {
        popupStyle.top = triggerElemRect.top - popupElemRect.height;
      } else if (dirMatch[0] === 'bottom') {
        popupStyle.top = triggerElemRect.top + triggerElemRect.height;
      } else if (dirMatch[0] === 'center') {
        popupStyle.top =          triggerElemRect.top
          - ((popupElemRect.height - triggerElemRect.height) / 2);
      }

      if (!isTriggerFixed) {
        popupStyle.top += window.scrollY || window.pageYOffset;
        popupStyle.left += window.scrollX || window.pageXOffset;
      }

      if (this.offset) {
        popupStyle.top += this.offset.y || 0;
        popupStyle.left += this.offset.x || 0;
      }

      domHelper.css(this.popupElem, popupStyle);

      // class for style arrow
      this.popupElem.className = this.popupElem.className
        .replace(/ten-popup--p-[\w-]+/g, '')
        .replace(/\s+/g, ' ');

      this.popupElem.classList.add(`ten-popup--p-${dirMatch[0]}-${dirMatch[1]}`);
    },

    resize() {
      this.setPopupPosition();
    },

    onClick() {
      this.togglePopup();
    },

    onMouseenter() {
      clearTimeout(this.mouseleaveT);
      this.showPopup();
    },

    onMouseleave() {
      this.mouseleaveT = setTimeout(() => {
        this.hidePopup();
      }, 150);
    },

    onClickOutside(e) {
      if (
        !this.popupShowed
        || domHelper.contains(this.popupElem, e.target)
        || domHelper.contains(this.triggerElem, e.target)
      ) {
        return;
      }
      this.hidePopup();
    },

    onKeydown(e) {
      if (e.keyCode === 27) {
        this.hidePopup();
      }
    },

    togglePopup() {
      this.popupShowed ? this.hidePopup() : this.showPopup();
    },

    showPopup() {
      if (this.disabled) {
        return;
      }
      if (this.triggerType !== 'manual') {
        this.popupShowed = true;
      }
      /**
       * 弹窗显示变换回调
       */
      this.$emit('change', true);
    },

    hidePopup() {
      if (this.disabled) {
        return;
      }
      if (this.triggerType !== 'manual') {
        this.popupShowed = false;
      }
      /**
       * 弹窗显示变换回调
       * @param {Boolean} visible
       */
      this.$emit('change', false);
    },
  },
};
